<template>
    <div>
        <card class="cursor-pointer mb-2" v-if="!integrated">
            <div class="p-3" @click="handleAuthClick">
                <img class="d-block m-auto"
                    src="/img/google-my-business-logo.png"
                    style="max-height: 60px;" />
            </div>
        </card>

        <card class="cursor-pointer mb-2" v-if="integrated">
            <div class="position-relative card__integrated">
                <div class="pt-3 pr-3 pl-3" @click="open">
                    <div class="text-center">
                        <img class="img-thumbnail rounded-circle"
                            :src="integration.google_my_business_account_picture"
                            style="max-width: 60px;">
                    </div>
                    <p class="mb-0">
                        {{ integration.google_my_business_account_name }}
                    </p>
                    <p class="mb-0">
                        {{ integration.google_my_business_account_email }}
                    </p>
                </div>
                <button type="button"
                    class="btn btn-danger btn-block position-absolute button--remove-account"
                    @click="removeAccount">
                    Remove account
                </button>
            </div>
        </card>

        <modal
            ref="modal"
            size="lg"
            :scrollable="true"
            :has-footer="false"
            @hide="close()">
            <div slot="title">Google Integration</div>
            <card-spinner
                v-if="loading"
                style="height: 200px;"
            />

            <div v-if="!loading">
                <h6 class="mb-3">
                    Choose a Google Location that you would like to integrate with
                    <strong>{{ location_name }}</strong>.
                </h6>

                <div class="row" v-if="locations.length">
                    <div class="form-group col-6" v-for="location of locations" :key="location.name">
                        <div class="media google-location"                        
                            :class="{'selected': isSelected(location)}"
                            @click="select(location)">
                            <div class="media-body align-self-center">
                                <div class="">
                                    <p class="d-flex justify-content-between location-name">
                                        <strong>{{ location.locationName }}</strong>
                                        <i class="fa fa-check" style="font-size: 24px"></i>
                                    </p>

                                    <p class="location-address">
                                        {{ location.address.postalCode }}
                                    </p>
                                    <p class="location-address">
                                        {{ location.address.administrativeArea }}
                                    </p>
                                    <p class="location-address">
                                        {{ location.address.locality }}
                                    </p>
                                    <p class="location-address"
                                        v-for="(address, index) in location.address.addressLines" :key="index">
                                        {{ address }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="!locations.length">
                    <div class="alert alert-warning mb-0">
                        Oops! It looks like you do not manage any Google My
                        Business account. This integration is available only to
                        users with a Google My Business account.
                    </div>
                </div>

                <div class="modal-footer mt-2 pr-0 pb-0 pl-0">
                    <button type="button" class="btn btn-default" @click="closeEdit()">
                        Cancel
                    </button>
                    <button-loading type="button" class="btn btn-primary ml-2"
                        v-if="locations.length"
                        :loading="form.submitting"
                        @click="save">
                        Save
                    </button-loading>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        props: ['integration'],

        data() {
            return {
                form: new Form(),
                location_name: '',
                loginUrl: null,
                loading: false,
                locations: []
            }
        },

        computed: {
            integrated() {
                return !!this.integration && !!this.integration.google_my_business_account_id;
            }
        },

        watch: {
            integration: {
                immediate: true,
                handler() {
                    if (this.integration && this.integration.id) {
                        if (!this.integration.google_my_business_account_id) {
                            return this.$http.get(this.$laroute.route('google-my-business-url', {
                                location: this.integration.id
                            })).then(({data}) => {
                                this.loginUrl = data.url;
                            });
                        }

                        this.location_name = this.integration.name;

                        this.form = new Form({
                            location_id: this.integration.id,
                            google_location_id: this.integration.google_my_business_location_id
                        });
                        return;
                    }

                    this.loginUrl = null;
                    this.form = new Form();
                }
            }
        },

        methods: {
            async open() {
                this.$refs.modal.open();
                this.$emit('show', true);
                this.loading = true;
                await this.$http.get(this.$laroute.route('locations-google', {
                        location: this.integration.id
                    })).then(({data}) => {
                        this.locations = data;
                        this.loading = false;
                    });
            },

            close() {                
                this.form.google_location_id = this.integration.google_my_business_location_id;              
                this.$emit('hide');
            },

            closeEdit() {
                this.$refs.modal.close();
            },

            handleAuthClick() {
                let win = window.open(this.loginUrl,
                    '_blank',
                    `
                        toolbar=no,
                        location=no,
                        directories=no,
                        status=no,
                        menubar=no,
                        scrollbars=no,
                        resizable=no,
                        copyhistory=no,
                        width=800,
                        height=700,
                        top=150,
                        left=500
                    `
                );

                let timer = setInterval(() => {
                    if (win.closed) {
                        clearInterval(timer);
                        this.$emit('save-integration', this.integration.id);
                    }
                }, 1000);
            },

            select(location) {
                this.form.google_location_id = location.name;
            },

            isSelected(location) {
                return location.name === this.form.google_location_id;
            },

            save() {
                return this.form.put(this.$laroute.route('location-google-integration.update', {
                    location: this.form.location_id
                }))
                .then(({data}) => {                    
                    swal.fire({
                        title: 'Location Saved!',
                        type: 'success',
                    }).then(() => {
                        this.$emit('save-integration', data.id);
                        this.closeEdit();
                    });
                })
                .catch(error => console.error(error));
            },

            removeAccount() {
                this.$confirm().then(() => {
                    this.form.put(this.$laroute.route('location-google-integration.destroy' , {
                        location: this.form.location_id
                    }))
                    .then(({data}) => {
                        this.$alert({
                            message: 'integration with Google has been successfully removed!',
                            type   : 'success',
                            title  : 'Success!'
                        })
                        .then(() => {
                            this.$emit('save-integration', data.id);
                        });
                    })
                    .catch(err => console.error(err))
                });
            },
        }
    }
</script>

<style lang="sass" scoped>
    $primary: #0374d7
    $light-grey: #e9ecef
    $effect-time: 0.15s
    .card__integrated
        padding-bottom: 2rem
    .button--remove-account
        left: 0
        bottom: 0
        height: 30px
        border-top-right-radius: 0
        border-top-left-radius: 0
        padding: 0
    .google-location
        background-color: white
        padding: 10px
        border-radius: 5px
        border: 1px solid $light-grey
        cursor: pointer
        transition: all $effect-time ease-in-out
        min-height: 155px

        &:hover
            border-color: darken($light-grey, 10%)
        &.selected
            border-color: $primary
            .location-name
                color: $primary
            .location-name i
                opacity: 1
                transform: scale(1)

        .location-name
            margin: 0
            i
                transition: all $effect-time ease-in-out
                opacity: 0
                transform: scale(0)
        .location-address
            margin: 0
            font-size: 12px
</style>
